var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28391 0.093652C9.06985 -0.0312173 8.80515 -0.0312173 8.59109 0.093652L0.6875 4.70408L8.9375 9.51658L17.1875 4.70408L9.28391 0.093652Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 5.89488L9.625 10.7074V18.9574L17.5339 14.3438C17.7451 14.2206 17.875 13.9945 17.875 13.75V5.89488Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.9574V10.7074L0 5.89488V13.75C0 13.9945 0.129876 14.2206 0.341089 14.3438L8.25 18.9574Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotConfig);
export default __webpack_public_path__ + "static/media/chatbot_config.d5d2f1867b2dd4b3095babbec74e0e08.svg";
export { ForwardRef as ReactComponent };